import { createStore } from 'vuex';
import userStore from './modules/userStore';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userStore,
  },
});
